// src/pages/MagazinePage.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './MagazinePage.css';
import { API_URL } from "../config";

function MagazinePage() {
    const [products, setProducts] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        fetchProducts();
    }, []);

    const fetchProducts = async () => {
        try {
            const response = await fetch(`${API_URL}/products?status=Gotowy`, {
                credentials: 'include'
            });
            if (!response.ok) throw new Error('Błąd pobierania produktów');
            const data = await response.json();
            setProducts(data);
        } catch (error) {
            console.error('Błąd:', error);
        }
    };

    return (
        <div className="magazine-page">
            <h2>Magazyn</h2>
            <div className="magazine-controls">
                <button className="btn-submit" onClick={() => navigate('/magazyn/dodaj')}>
                    Dodaj Produkt
                </button>
                <button className="btn-submit" onClick={() => navigate('/magazyn/nowe')}>
                    Nowe Produkty
                </button>
            </div>
            <table className="products-table">
                <thead>
                    <tr>
                        <th>Nazwa</th>
                        <th>Kategoria</th>
                        <th>Ilość</th>
                        <th>Lokalizacja</th>
                    </tr>
                </thead>
                <tbody>
                    {products.map(product => (
                        <tr key={product.id}>
                            <td>{product.name}</td>
                            <td>{product.category_name}</td>
                            <td>{product.quantity}</td>
                            <td>{product.location_name || '-'}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default MagazinePage;